import { useMemo, useState } from "react";
import { CalcSlider, CalcDonut, StatPill, fmtINR } from "./CalcShared";
import { CALC } from "@/constants/testIds";

export default function LumpsumCalculator() {
  const [amount, setAmount] = useState(100000);
  const [years, setYears] = useState(10);
  const [rate, setRate] = useState(12);

  const result = useMemo(() => {
    const future = Math.round(amount * Math.pow(1 + rate / 100, years));
    return { invested: amount, future, gain: future - amount };
  }, [amount, years, rate]);

  return (
    <div className="grid md:grid-cols-2 gap-8" data-testid={CALC.lumpsumCard}>
      <div className="space-y-6">
        <CalcSlider
          label="Investment amount"
          value={amount}
          onChange={setAmount}
          min={1000}
          max={10000000}
          step={1000}
          format={fmtINR}
          testId={CALC.lumpAmount}
        />
        <CalcSlider
          label="Investment period"
          value={years}
          onChange={setYears}
          min={1}
          max={40}
          step={1}
          format={(v) => `${v} yr`}
          testId={CALC.lumpYears}
        />
        <CalcSlider
          label="Expected annual return"
          value={rate}
          onChange={setRate}
          min={4}
          max={20}
          step={0.5}
          format={(v) => `${v}%`}
          testId={CALC.lumpRate}
        />
      </div>

      <div className="bg-muted/40 rounded-2xl p-6">
        <CalcDonut invested={result.invested} returns={result.gain} />
        <div className="grid grid-cols-3 gap-3 mt-4" data-testid={CALC.lumpResult}>
          <StatPill label="Invested" value={fmtINR(result.invested)} />
          <StatPill label="Returns" value={fmtINR(result.gain)} tone="secondary" />
          <StatPill label="Future Value" value={fmtINR(result.future)} tone="primary" />
        </div>
      </div>
    </div>
  );
}
